var Backbone = require('backbone');
var _ = require('underscore/underscore');

var Base = require('front/components/Base/Base');

require('./SendButton.less');

module.exports = Base.extend({
    template: require('./SendButton.jinja'),

    el: '.SendButton',

    initialize: function (options) {
        Base.prototype.initialize.call(this, options);
        _.bindAll(this, 'onSuccess', 'onFail');
    },

    onSuccess: function () {
        var self = this;

        this.$el.removeClass('SendButton--loader').addClass('SendButton--success')
                        .delay(2000)
                        .queue(function () {
                            self.$el.removeClass('SendButton--success').dequeue();
                        });
    },

    onFail: function () {
        var self = this;

        this.$el.removeClass('SendButton--loader').addClass('SendButton--repeat')
                        .delay(2000)
                        .queue(function () {
                            self.$el.removeClass('SendButton--repeat').dequeue();
                        });
    },

    submit: function (data, apiUrl) {
        var xhr = new XMLHttpRequest();
        this.$el.addClass('SendButton--loader');

        if (apiUrl) {
            xhr.open('POST', apiUrl);
            xhr.setRequestHeader('X-CSRFToken', $('meta[name="csrf-token"]').attr('content'));
            xhr.onload = this.onSuccess;
            xhr.onerror = this.onFail;

            xhr.send(data);
        } else {
            $.post('/api/callback/', data)
                .done(this.onSuccess)
                .fail(this.onFail);
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/SendButton/SendButton.js
// module id = 9
// module chunks = 0